// removed by extract-text-webpack-plugin
module.exports = {"root":"_17KroMP","filters":"_3mezkrL","filters_isExpanded":"_2XW3brR","transition-enter":"_1qHwz0S","transition-enter-active":"_3FaVQWk"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Search/Search.less
 ** module id = 897
 ** module chunks = 0
 **/